<template>
  <div class="py-4 container-fluid">
    <GridRow>
      <GridCol :size="12">
        <MetaSection>
          <div class="text-right">
            <ArgonButton :to="{ name: ($route.name == 'Log Aktivitas User' ? 'User' : 'Manajemen Pegawai') }" isRouteLink>Kembali</ArgonButton>
          </div>
        </MetaSection>
      </GridCol>
      <GridCol md="12">
        <CardComponent :useHeader="true">
          <template v-slot:header-action>
            <GridRow class="w-100">
              <GridCol md="6">
                <div class="d-flex flex-row align-items-center justify-content-between gap-2">
                  <div class="input-group">
                    <span class="input-group-text text-body">
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </span>
                    <input v-model="params.keyword" @keyup="getData()" type="text" class="form-control"
                      placeholder="Type here...">
                  </div>

                  <FormGroup class="m-0 w-100">
                    <select-form v-model="params.event"
                      :options="[{ text: 'Semua Aktifitas', value: '' }, { text: 'Login', value: 'login' }, { text: 'Login Gagal', value: 'login_failure' }, { text: 'Updated', value: 'updated' }, { text: 'Registered', value: 'registered' }, { text: 'Sync', value: 'sync' }]" />
                  </FormGroup>
                </div>
              </GridCol>
            </GridRow>
          </template>
          <list-view>
            <template v-slot:thead>
              <tr>
                <th scope="col" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Tanggal</th>
                <th scope="col" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Tipe Aktivitas</th>
                <th scope="col" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Fitur</th>
              </tr>
            </template>
            <template v-slot:tbody>
              <tr v-if="data.length < 1">
                <td colspan="5" class="text-center text-secondary">Tidak ada data</td>
              </tr>
              <tr v-for="(item, index) in data" :key="index">
                <td>
                  <h6 class="mb-0 text-sm">{{ item.created_at }}</h6>
                </td>
                <td>
                  <argon-badge v-if="item.event == 'updated'" color="warning">{{ item.event ?? "" }}</argon-badge>
                  <argon-badge v-else color="success">{{ item.event ?? "" }}</argon-badge>
                </td>
                <td>{{ item.type ?? "" }}</td>
              </tr>
            </template>
            <div class="d-flex flex-row flex-wrap gap-2 justify-content-center align-items-center">
              <button type="button" @click="params.page = params.page - 1"
                class="btn btn-light rounded-circle"><font-awesome-icon icon="fa-solid fa-chevron-left" /></button>
              <p>{{ metaData?.current_page ?? "&infin;" }} / {{ metaData?.total_page ?? "&infin;" }}</p>
              <button type="button" @click="params.page = params.page + 1"
                class="btn btn-light rounded-circle"><font-awesome-icon icon="fa-solid fa-chevron-right" /></button>
            </div>
          </list-view>
        </CardComponent>
      </GridCol>
    </GridRow>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent.vue';
import LogApi from '@/repository/api/LogApi';
// import ThreeDotsMenu from '@/components/ThreeDotsMenu.vue';
import ArgonButton from '@/components/ArgonButton.vue';
import ArgonBadge from '../../components/ArgonBadge.vue';
import GridRow from '@/components/grid/GridRow.vue';
import GridCol from '@/components/grid/GridCol.vue';
import MetaSection from '@/components/MetaSection.vue';
import ListView from '@/components/ListView.vue';
import SelectForm from '../../components/SelectForm.vue';
import moment from 'moment';

export default {
  name: "tables",
  components: {
    CardComponent,
    // ThreeDotsMenu,
    ArgonButton,
    GridRow,
    GridCol,
    MetaSection,
    ListView,
    SelectForm,
    ArgonBadge,
  },
  data() {
    return {
      timer: undefined,
      data: [{}],
      keyword: "",
      params: {
        relate_id: "",
        type: ["authlog", "employeelog"],
        keyword: "",
        event: "",
        page: 1,
      },
      user: {},
      metaData: {}
    };
  },
  watch: {
    'params.page': {
      handler: async function (newVal, oldVal) {
        if (newVal < 1) {
          this.params.page = oldVal
        }
        else {
          await this.getData();
        }
      },
      deep: false,
    },
    'params.event': {
      handler: async function () {
        this.params.page = 1;
        await this.getData();
      },
      deep: true,
    },
  },
  async mounted() {
    await this.getData();
  },
  methods: {
    dateFormat(date) {
      date = String(date).split("T")
      date[1] = String(date[1]).split(".")[0]
      date = date.join(" ")
      return date;
    },
    async getData() {
      this.params.relate_id = this.$route.params.id
      clearTimeout(this.timer)
      if (this.params.keyword.length <= 0) {
        await this.getDataAll();
      }
      else if (this.params.keyword.length >= 2) {
        this.timer = setTimeout(async () => {
          await this.getDataAll();
        }, 1500)
      }
    },
    getEmployePhoto(path) {
      return "http://localhost:9100" + path;
    },
    async getDataAll() {
      this.$store.state.loading = true;
      let params = {}
      Object.keys(this.params).forEach(key => {
        if (!(this.params[key] === undefined || this.params[key] === null || this.params[key] === "")) {
          params[key] = this.params[key];
        }
      });
      await LogApi.user(params).then((response) => {
        this.data = response.data;
        this.data.map((item) => {
          item.created_at = moment.utc(item.created_at).utcOffset('+0700').format('DD MMMM YYYY, HH:mm');
        })
        this.metaData = {
          status: response?.status ?? null,
          message: response?.message ?? null,
          total_item: response?.total_item ?? null,
          per_page: response?.per_page ?? null,
          total_page: response?.total_page ?? null,
          current_page: response?.current_page ?? null,
        }
      }).catch((error) => {
        if ((error?.response?.data?.detail ?? "") == 'Invalid page.') {
          this.params.page = this.params.page - 1;
        }
        this.data = []
      })
      this.$store.state.loading = false;
    },
    async deleteData(id) {
      this.$swal({
        icon: "warning",
        title: "Apakah anda yakin ingin menghapus?",
        showCancelButton: true,
      }).then(async (response) => {
        if (response.isConfirmed) {
          this.$store.state.loading = true;
          await LogApi.delete(id).then(() => {
            this.getData();
            this.$swal({
              icon: "success",
              title: "Berhasil"
            });
          }).catch((error) => {
            this.$swal({
              icon: "error",
              title: "Error",
              text: error.response.data.message,
            });
          });
          this.$store.state.loading = false;
        }
      });
    }
  },
};
</script>
